import { createComponent } from '@carvana/merch-components';
import { ElementWithProps } from '@carvana/merch-components/dist';
import cx from 'classnames';

export const Content = createComponent('div', {
  className: 'flex flex-col gap-md'
});

export const Subtitle = createComponent<
  ElementWithProps<{ disabled: boolean }>
>('p', ({ disabled }) => ({
  className: cx(
    't-label-sm',
    disabled ? 'text-text-disabled' : 'text-text-strong'
  )
}));
